import { Link, useNavigate, useLocation } from "react-router-dom";
import { GraduationCap, LogIn } from "lucide-react";
import { motion } from "framer-motion";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Inspirations", to: "/inspirations" },
  { label: "Notices", to: "/notices" },
  { label: "Info Gallery", to: "/gallery" },
  { label: "Socials", to: "/socials" },
];

export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goLogin = () => {
    if (location.pathname === "/") {
      document.getElementById("login")?.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      navigate("/");
      setTimeout(() => document.getElementById("login")?.scrollIntoView({ behavior: "smooth", block: "center" }), 400);
    }
  };

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-sky-100 bg-white/85 py-3 shadow-sm backdrop-blur-xl"
      data-testid="main-navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 sm:px-10 lg:px-14">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-brand-link">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sky-700 text-white">
            <GraduationCap size={18} />
          </span>
          <span className="leading-tight">
            <span className="block font-display text-lg font-bold text-slate-900">Jyoti Academy</span>
            <span className="block text-[10px] font-semibold tracking-wide text-amber-700">Find your unknown, work on it, level up</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-sky-700"
            >
              {l.label}
            </Link>
          ))}
          <button
            onClick={goLogin}
            data-testid="nav-portal-login-button"
            className="flex items-center gap-2 rounded-full bg-sky-700 px-5 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-sky-800"
          >
            <LogIn size={15} /> Portal Login
          </button>
        </nav>

        <button
          onClick={goLogin}
          data-testid="nav-portal-login-button-mobile"
          className="flex items-center gap-2 rounded-full bg-sky-700 px-4 py-2 text-sm font-semibold text-white md:hidden"
        >
          <LogIn size={15} /> Login
        </button>
      </div>
    </motion.header>
  );
};
